import Icon from '../../Utilites/Icon';

import { convertToRoman } from '../../Core/Functions';
import { appTitle, availableLanguages } from '../../Core/Config';
import { useTranslation } from 'react-i18next';

const QuizHeader = ({ lang, group, area, quiz, onSelectLanguage, onBack, location }) => {
    const { t } = useTranslation();

    const handleBackToGroupSelection = () => {
        onBack('/quiz/select-group');
    };

    const handleBackToAreaSelection = () => {
        onBack('/quiz/select-area');
    };

    const handleBackToQuizSelection = () => {
        onBack('/quiz/select-quiz');
    }; 

    const handleQuitQuiz = () => {
        onBack('/quiz/select-quiz');
    };


const generateTitle = (lang, area, quiz, location) => {
    const { pathname } = location;

    switch (pathname) {
        case '/quiz':
            return <h1 className="area-title text-primary">{t('choose-language')}</h1>; 
        case '/quiz/select-group':
            return <h1 className="area-title text-primary">{t('select-group')}</h1>;
        case '/quiz/select-area':
            return <h1 className="area-title text-primary">{t('select-area')}</h1>;
        case '/quiz/select-quiz':
            return <h1 className="area-title text-primary">{t('select-quiz')}</h1>;
        case '/quiz/select-level':
            return <h1 className="area-title text-primary">{t('select-level')}</h1>;
        case '/quiz/play':
            if (area?.name) {
                return (
                    <h1 className="area-title text-primary">
                        {area.name} {quiz?.number ? convertToRoman(quiz.number) : ''}
                    </h1>
                );
            }
            break;
        default:
            return <h1 className="area-title text-primary">{appTitle}</h1>;
    }
};

    const homeButton = () => {
    
        if (lang.code) {

            return (         
                <div className="">
                    <button onClick={onSelectLanguage}
                            aria-label={t('choose-language')}
                            className="btn-clear">

                            <span className={`lang-icon btn-primary btn`} key={`lang-${lang.code}`}><span>
                                {lang.code === 'cs' ? (
                                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="120" height="80" className="bg-[#ff0000]"><rect width="120" height="40" fill="#fff" /><path d="M 60,40 0,0 V 80 z" fill="#11457e" /></svg>
                                ) : lang.code === 'en' ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="120" height="80"><clipPath id="s"><path d="M0,0 v30 h60 v-30 z" /></clipPath><clipPath id="t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath><g clipPath="url(#s)"><path d="M0,0 v30 h60 v-30 z" fill="#012169" /><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" /><path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="8" /><path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" /><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" /></g></svg>
                                ) : lang.code === 'es' ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="80" viewBox="0 0 20 15"><rect width="20" height="15" fill="#ff0000" /><rect width="20" height="7" fill="#ffcc00" y="5" /><rect width="20" height="7" fill="#ff0000" y="10" /></svg>
                                ) : lang.code === 'fr' ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2" width="90" height="90"><rect width="1" height="2" x="0" y="0" fill="#0055A4"/><rect width="1" height="2" x="1" y="0" fill="#FFFFFF"/><rect width="1" height="2" x="2" y="0" fill="#EF4135"/></svg>    
                                ) : lang.code === 'de' ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 3" width="120" height="80"><rect width="5" height="3" fill="#FFCE00"/><rect width="5" height="2" fill="#DD0000"/><rect width="5" height="1" fill="#000000"/></svg>
                                ) : (
                                    <span className="text-primary">{lang.code}</span>
                                )}
                            </span></span>
                    </button>  
                </div>         
            );      
        } else {
            return (<></>);
        }


    

    };

    const generateButtons = (lang, area, quiz, location) => {
        const buttons = []; 

        switch (location.pathname) {
            case '/quiz/select-group':

                if (availableLanguages.length > 1) {
                    buttons.push(
                        <button
                            key="backButton"
                            className="btn-red btn-ico"
                            aria-label={t('back-to-home')}
                            onClick={onSelectLanguage}
                        >
                            <Icon name="arrow_back" />
                            <span className="text !hidden">{t('back-to-home')}</span>
                        </button>
                    );
                }


            break;           
            case '/quiz/select-area':

               // if (availableLanguages.length > 1) {
                    buttons.push(
                        <button
                            key="backButton"
                            className="btn-red btn-ico"
                            aria-label={t('back-to-group-selection')}
                            onClick={() => handleBackToGroupSelection()}
                        >
                            <Icon name="arrow_back" />
                            <span className="text !hidden">{t('back-to-group-selection')}</span>
                        </button>
                    );
               // }


            break;
            case '/quiz/select-quiz':

                buttons.push(
                        <button
                            key="backButton"
                            className="btn-red btn-ico"
                            aria-label={t('back-to-select-area')}
                            onClick={() => handleBackToAreaSelection()}
                        >
                        <Icon name="arrow_back" />
                        <span className="text !hidden">{t('back-to-select-area')}</span>
                        </button>
                    );

            break;
            case '/quiz/select-level':
                buttons.push(
                    <button
                        key="backButton"
                        className="btn-red btn-ico"
                        aria-label={t('back-to-select-quiz')}
                        onClick={() => handleBackToQuizSelection()}
                    >
                        <Icon name="arrow_back" />
                        <span className="text !hidden">{t('back-to-select-quiz')}</span>
                    </button>
                );
            break;          
            case '/quiz/play':

                buttons.push(
                        <button
                            key="backButton"
                            className="btn-red btn-ico"
                            aria-label={t('quit-quiz')}
                            onClick={() => handleQuitQuiz()}
                        >
                        <Icon name="close" />
                        <span className="text hidden">{t('quit-quiz')}</span>
                        </button>
                    );

            break;
            default:
                break;
        }

        return <div className="">{buttons}</div>; // Vrátí tlačítka v kontejneru
    };


    return (
        <div id="quiz-header">
            <div id="quiz-topbar">
            
                {homeButton()}

                {generateTitle(lang, area, quiz, location)}

                {generateButtons(lang, area, quiz, location)}
                      
            </div>
        </div>
    );
};

export default QuizHeader;
